import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, lastValueFrom, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSubject = new BehaviorSubject<any>(this.getUserFromStorage());
  user$ = this.userSubject.asObservable();
  private apiUrl = environment.API_URL;

  constructor(
    private http: HttpClient
  ) { }

  async setUser(user: any): Promise<any> {
    if (!user) {
      return { status: false, code: 404, message: 'No user' };
    }

    if (!user.userData?.['custom:Services']) {
      console.error('Missing required Cognito attribute: custom:Services');
      return { status: false, code: 403, message: 'Missing required attribute: custom:Services' };
    }

    try {
      const response = await lastValueFrom(this.getUserQueues(user));
      const data = response.data;
      
      const uniqueQueues: any[] = [...new Set(data.map((queue: any) => queue.Name))].map(name => {
        return data.find((queue: any) => queue.Name === name);
      });
      user['user_queues'] = data;
      user['user_services'] = Array.from(new Set(
          uniqueQueues
              .map((queue: any) => queue.Service)
              .filter((service: string) => service !== "N/A")
      ));      
      this.userSubject.next(user);
      this.saveUserToStorage(user);

      return { status: true, code: 200, message: 'User saved' };
    } catch (error) {
      console.error('Error al obtener datos del usuario:', error);
      return { status: false, code: 401, message: 'Invalid config' };
    }
  }

  getUser() {
    return this.userSubject.value;
  }

  removeUser() {
    localStorage.removeItem('user');
    localStorage.clear();

  }

  private saveUserToStorage(user: any) {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }

  private getUserFromStorage(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

private getUserQueues(userInfo: any) {
  let services = userInfo.userData['custom:Services'];
  console.log('Services original:', services);
  
  // Parsear el string a array si es necesario
  let servicesArray = services;
  if (typeof services === 'string') {
    try {
      // Reemplazar comillas simples por dobles y parsear
      servicesArray = JSON.parse(services.replace(/'/g, '"'));
    } catch (error) {
      console.error('Error parsing services:', error);
      servicesArray = [];
    }
  }
  
  // Asegurar que sea un array
  if (!Array.isArray(servicesArray)) {
    servicesArray = [];
  }
  
  console.log('Services parseado:', servicesArray);
  
  let httpOptions = {
    headers: new HttpHeaders({
      Authorization: `Bearer ${userInfo.accessToken}`,
    })
  };

  const body = { services: servicesArray };

  return this.http.post<any>(this.apiUrl + 'user-info/queues', body, httpOptions).pipe(
    catchError(this.handleError)
  );
}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
